/* eslint-disable max-len */
import React,{useState,useEffect, useContext} from 'react'
import BranchSelection from '../BranchSelection'
import GlobalContext from '../Context/GloablContext'

function    BranchModal({show,handleClose}) {
    const {setToastmessage} =useContext(GlobalContext)
    const [currentBranch, setcurrentBranch] = useState({})
    useEffect(() => {
        setcurrentBranch(JSON.parse(localStorage.getItem('branch_details')))
    }, [])
    const handleVerify =(item,message)=>{
        localStorage.setItem('branch_details',JSON.stringify({name:item.name,id:item.id}))
        setToastmessage(message)
        handleClose();

    }
    return (
        
        
        <div data-te-modal-init  class={`fixed left-0 top-0 z-[1055] ${show?'show':'hidden'} h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-[#00000047]`} id="modal_switch_branch" tabindex="-1" aria-labelledby="modal_switch_branchTitle" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-100 transition-all duration-300 ease-in-out min-w-[517px] mx-auto max-w-[517px]">
                <div class="pointer-events-auto relative flex w-full flex-col border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 min-w-[517px] mx-auto max-w-[517px] p-5 rounded-[20px]">
                    <div class="flex flex-shrink-0 items-center justify-center rounded-t-md">
                        <p class="text-xl font-semibold text-[#031624] text-center">Select Branch</p>
                        <button type="button" class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none absolute top-5 right-5"
                            data-te-modal-dismiss aria-label="Close" onClick={()=>handleClose()}>
                            <img loading="lazy" decoding="async" src="/images/modal_closeThin.png" alt="icon" />
                        </button>
                    </div>
                    <div class="relative pl-8 pr-[18px] pt-3">
                        <div class="p-2.5 rounded-lg bg-[#EEF7FE]">
                            <p class="text-f1 font-normal text-[#4D555B]">Current Branch</p>
                            <p class="text-f2 font-semibold text-[#031624] pt-3">{currentBranch?.name}</p>
                        </div>
                        <BranchSelection currentBranch={currentBranch} handleClose={handleClose} handleVerify={handleVerify}/>
                    </div>
                
                </div>
            </div>
        </div>
    )
}

export default BranchModal